import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearUser, fetchUser } from './../../redux/userSlice';
import { FiUser, FiChevronDown } from 'react-icons/fi';
import { swalAlert } from './../../utils';
import UserSignInModal from './UserSignInModal';
import HeaderUserMenuContent from './inc//HeaderUserMenuContent';
import { FiBell } from "react-icons/fi";
import './header-user.css';
function Header_User() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSignInModal, setShowSignInModal] = useState(false);
  const [showAdminChoiceModal, setAdminChoiceModal] = useState(false);
  const dropdownRef = useRef(null);
  // 🔁 Poll user every 60s
  useEffect(() => {
    const intervalId = window.setInterval(() => {
      dispatch(fetchUser());
    }, 60000);
    dispatch(fetchUser());
    return () => window.clearInterval(intervalId);
  }, [dispatch]);



  // 🖱 Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleSignInSuccess = () => {
    if (user.isAdmin) {
      setAdminChoiceModal(true);
    }
  };
  const handleSignOut = () => {
    swalAlert('Vous êtes déconnecté.');
    dispatch(clearUser());
    setShowDropdown(false);
    navigate('/');
  };
  const handleNavigate = (path) => {
    setShowDropdown(false);
  };
  return (
    <div id="header-user" className="position-relative" ref={dropdownRef}>
      {/* Trigger */}
      <div
        className="d-flex align-items-center pointer gap-1"
        onClick={() => setShowDropdown(prev => !prev)}
      >
        <FiUser
          size={28}
          className={user.isSignedIn ? "text-primary" : "text-muted"}
        />
        {user.pendingOrders > 0 && <span className="badge bg-danger"><FiBell /></span>}
        <FiChevronDown
          size={16}
          style={{ left: "-5px", top: "-5px", position: "relative" }}
        />
      </div>
      {/* Dropdown */}
      {showDropdown && (
        <div
          className="dropdown-menu show mt-2"
          style={{ right: 0, left: 'auto' }}
        >
          <HeaderUserMenuContent
            user={user}
            onSignIn={() => {
              setShowDropdown(false);
              setShowSignInModal(true);
            }}
            onSignOut={handleSignOut}
            onNavigate={handleNavigate}

          />
        </div>
      )}
      {/* SignIn Modal */}
      {showSignInModal && (
        <UserSignInModal
          show={showSignInModal}
          onClose={() => setShowSignInModal(false)}
          onSuccess={() => {
            setShowSignInModal(false);
            dispatch(fetchUser());
            handleSignInSuccess();
          }}
        />
      )}
      {/* Admin choice modal */}
      {showAdminChoiceModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title text-center w-100">
                  Choisir un espace
                </div>
              </div>
              <div className="modal-body text-center pt-4 pb-5 d-flex flex-column gap-4">
                <button
                  className="btn btn-outline-primary w-100 rounded-pill"
                  onClick={() => {
                    setAdminChoiceModal(false);
                    navigate('/admin');
                  }}
                >
                  Espace administration
                </button>
                <button
                  className="btn btn-outline-secondary w-100 rounded-pill"
                  onClick={() => {
                    setAdminChoiceModal(false);
                    navigate('/customer/account');
                  }}
                >
                  Mon compte client
                </button>
                <button
                  className="btn btn-outline-secondary w-100 rounded-pill"
                  onClick={() => {
                    setAdminChoiceModal(false);
                  }}
                >
                  Rester sur cette page
                </button>
              </div>
            </div>
          </div>
          <div
            className="modal-backdrop fade show"
            onClick={() => setAdminChoiceModal(false)}
          />
        </div>
      )}
    </div>
  );
}
export default Header_User;